import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "PopupBaseUserInfo"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FormIndustry = _resolveComponent("FormIndustry");
  const _component_FormArea = _resolveComponent("FormArea");
  const _component_FormRender = _resolveComponent("FormRender");
  const _component_PopupContainer = _resolveComponent("PopupContainer");
  return _openBlock(), _createBlock(_component_PopupContainer, {
    popupParams: _ctx.popupParams,
    popupService: _ctx.popupService
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_FormRender, {
      form: _ctx.form,
      submit: _ctx.handleSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_FormIndustry, {
        modelValue: _ctx.form.industries,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.industries = $event),
        field: _ctx.formFields.industries
      }, null, 8, ["modelValue", "field"]), _createVNode(_component_FormArea, {
        modelValue: _ctx.form.city,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.city = $event),
        field: _ctx.formFields.city
      }, null, 8, ["modelValue", "field"])]),
      _: 1
    }, 8, ["form", "submit"])])]),
    _: 1
  }, 8, ["popupParams", "popupService"]);
}